export enum Round {
    PRICE = 10000,
    AREA = 5,
    PRICE_M2 = 500
}
export enum Round {
    PRICE = 10000,
    AREA = 5,
    PRICE_M2 = 500
}
